'use client';

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import { useGameFormProvider } from './GameFormProvider';
import { RoundInputs } from './RoundInputs';

export const PicturesInputs = () => {
  const { rounds } = useGameFormProvider();

  return (
    <div className="flex w-full flex-col items-center">
      <div className="mb-4 flex flex-row text-base font-semibold">
        <ImageOutlinedIcon className="pr-1" /> Pictures
      </div>
      <InfoText />
      {rounds.map((round, index) => (
        <RoundInputs key={index} index={index} round={round} />
      ))}
    </div>
  );
};

const InfoText = () => {
  return (
    <div className="border-b border-secondary pb-3 text-xs">
      To create your game, upload 5 pictures. We will try and pull the
      information about the year and location from your images to fill out the
      details but you can always edit them later.
    </div>
  );
};
